<template>
    <div id="bar-chart-container" style='display:block'>
        <ejs-chart class="chart-content home-bar-chart" :legendSettings="legendSettings" :theme='theme' ref="lineInstance" :title="title" useGroupingSeparator='true' :tooltip="tooltip" style='display:block;' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :chartArea='chartArea' :palettes='palettes'>
            <e-series-collection>
                <e-series :dataSource='powerData' type='Column' xName='name' yName='value' name='Power' width=2 :marker='marker'> </e-series>
                <e-series :dataSource='gasData' type='Column' xName='name' yName='value' name='Gas' width=2 :marker='marker' > </e-series>
            </e-series-collection>
        </ejs-chart>
    </div>
</template>
<script>
    import Vue from "vue";
    import { ChartPlugin, ColumnSeries, Category, DataLabel, Tooltip, Legend } from "@syncfusion/ej2-vue-charts";
    Vue.use(ChartPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");

    export default {
        data() {
            return {
                theme: theme,
                palettes: ["#7FB7BE", "#Dae0f2"],
                gasData: this.$store.state.homeVolumeData.gasData,
                powerData: this.$store.state.homeVolumeData.powerData,
                tooltip: {enable: true},
                title: " ",
                primaryXAxis: {
                    valueType: 'Category',
                    interval: 1,
                    majorGridLines: { width: 0 },          
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                  
                },
                legendSettings: {
                    textStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                chartArea: {
                    border: { width: 0 }
                },
                primaryYAxis:
                {
                    majorGridLines: { width: 0 },
                    majorTickLines: { width: 1 },
                    lineStyle: { width: 1 },
                    labelFormat: 'n2',
                    title: 'GWh',
                    titleStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                    
                    
                },
                marker:
                {
                    dataLabel:
                    {
                        visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' }
                    }

                },
            };
        },
        provide: {
            chart: [ColumnSeries, Category, DataLabel, Tooltip, Legend]
        },
        mounted() {
            //Comment by Haris error console mutation problem, vue wants property like it allready is in ejs-chart
            this.$refs.lineInstance.height = "500px";
            //this.$refs.lineInstance.width = "100%";
        }
    };
</script>

<style>
    .dashboard-dynamic .chart-content, .dashboard-dynamic #bar-chart-container {
        height: 100%;
        width: 100%;
    }
    #bar-chart-container{
        background: white!important;
    }

    text[id$="_tooltip_text"] tspan {
        font-size: 10.5px !important;
        font-weight: normal !important;
    }

</style>